/* eslint-disable no-undef */
(function (window) {
	"use strict";
	function defineSecurityService() {
		let securityService = {};
		securityService.generatePassword = function (request) {
			return axios.post("/api/SecurityService/GeneratePassword", request);
		};
		securityService.generateCustomerCode = function () {
			return axios.get("/api/SecurityService/GenerateCustomerCode");
		};
		securityService.getRoles = function (){
			return [
				{
					roleId: roleHelper.role.admin,
					role: "Admin"
				},
				{
					roleId: roleHelper.role.userType1,
					role: "User Type 1"
				},
				{
					roleId: roleHelper.role.userType2,
					role: "User Type 2"
				},
				{
					roleId: roleHelper.role.specialUser,
					role: "Special User"
				}
			];
		}
		securityService.getRolePermissions = function () {
			return axios.get("/api/SecurityService/GetRolePermissions");
		};
		securityService.addOrUpdateUser = function (request) {
			return axios.post("/api/SecurityService/AddOrUpdateUser", request);
		};
		securityService.markUserAsActiveOrInactive = function (request) {
			return axios.post("/api/SecurityService/MarkUserAsActiveOrInactive", request);
		};
		securityService.getUser = function (userId) {
			return axios.get("/api/SecurityService/GetUser?userId=" + userId);
		};
		securityService.resetPassword = function (request) {
			return axios.post("/api/SecurityService/ResetPassword", request);
		};
		securityService.updatePassword = function (request) {
			return axios.post("/api/SecurityService/UpdatePassword", request);
		};
		securityService.getUserOrderTypePermissions = function () {
			return axios.get("/api/SecurityService/GetUserOrderTypePermissions");
		};
		securityService.getAllInternalUsers = function (request) {
			return axios.post("/api/SecurityService/GetAllInternalUsers", request);
		};
		return securityService;
	}
	//define globally if it doesn't already exist
	if (typeof (securityService) === "undefined") {
		window.securityService = defineSecurityService();
	} else {
		console.log("securityService already defined.");
	}
})(window);